// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type BookingModificationContextProperties = {
  'journey-booking-id'?: string;
  'journey-transport-mode'?: 'ferry' | 'flight' | 'train' | 'bus' | 'unknown';
  'arrival-datetime'?: string;
  'journey-passenger-count'?: number;
  'journey-provider-name'?: string;
  'journey-direction'?: 'inbound' | 'outbound';
  'journey-carrier-names'?: string[];
  'departure-datetime'?: string;
  'journey-ticket-exchangeability'?:
    | 'exchangeable'
    | 'non-exchangeable'
    | 'semi-exchangeable'
    | 'unknown';
  'journey-type'?: 'one-way' | 'round-trip';
};

/* Context definition block */
const schema = 'iglu:com.goeuro/booking-modification-context/jsonschema/1-0-0';
export const bookingModificationContextName = 'booking-modification-context';
export class BookingModificationContext extends BaseTrackingContext<BookingModificationContextProperties> {
  constructor(properties: BookingModificationContextProperties) {
    super(bookingModificationContextName, schema, properties);
  }
}
